import { render, staticRenderFns } from "./OtherOptions.vue?vue&type=template&id=3cf13fa9"
import script from "./OtherOptions.vue?vue&type=script&lang=ts"
export * from "./OtherOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports